import { createFileRoute, Link, useParams } from "@tanstack/react-router";
import { AutomationPage } from "../components/automation/AutomationPage";
import { ArchivedNotice, ManagedProjectGate } from "../components/projects/ProjectStates";
import { Skeleton } from "../components/ui/skeleton";
import { useProject } from "../lib/projects";
import { strings } from "../lib/strings";
import { PageTitle } from "../lib/title";

const words = strings.automation;

/** A project's automation (BUILD_SPEC §17), for those who configure it: its admins and Steer's Administrators. */
function AutomationRoute() {
  const { projectKey } = useParams({ from: "/admin/p/$projectKey/automation" });
  const project = useProject(projectKey);
  return (
    <ManagedProjectGate
      project={project}
      what={words.manage}
      skeleton={
        <div className="mx-auto max-w-5xl space-y-3 px-6 py-8">
          <Skeleton className="h-8 w-48" />
          <Skeleton className="h-40 w-full" />
        </div>
      }
    >
      {(detail) => (
        <div className="mx-auto max-w-5xl space-y-6 px-6 py-8">
          <PageTitle name={`${words.title} · ${detail.project.name}`} />
          <header className="flex items-center gap-2 text-sm text-[hsl(var(--muted-foreground))]">
            <Link to="/admin/p/$projectKey" params={{ projectKey: detail.project.key }} className="hover:underline">
              {detail.project.name}
            </Link>
            <span>·</span>
            <Link
              to="/admin/p/$projectKey/settings"
              params={{ projectKey: detail.project.key }}
              className="hover:underline"
            >
              {strings.projects.settings.title}
            </Link>
            <span>·</span>
            <h1 className="text-[hsl(var(--foreground))]">{words.title}</h1>
          </header>
          <ArchivedNotice project={detail.project} canManage={detail.canManage} />
          <AutomationPage project={detail} />
        </div>
      )}
    </ManagedProjectGate>
  );
}

export const Route = createFileRoute("/admin/p/$projectKey/automation")({ component: AutomationRoute });
